import { defineAsyncComponent } from 'vue';

export const revenueReportForecastFrontends = {
	RevenueReportForecast: defineAsyncComponent(
		() => import('./components/RevenueReportForecast')
	),
	RevenueReportForecastChartDashlet: defineAsyncComponent(
		() => import('./components/RevenueReportForecastChartDashlet')
	),
	RevenueReportForecastTableDashlet: defineAsyncComponent(
		() => import('./components/RevenueReportForecastTableDashlet')
	),
};
